<!--
  Общая точка входа для проектных SVG-иконок.
  Используется там, где иконку нужно выбирать по имени и сохранять единый API size/stroke.
-->
<template>
  <component
    :is="iconComponent"
    v-bind="iconProps"
  />
</template>

<script>
import AddSquareIcon from "@/components/Icon/icons/AddSquareIcon.vue";
import BellIcon from "@/components/Icon/icons/BellIcon.vue";
import CalibrationIcon from "@/components/Icon/icons/CalibrationIcon.vue";
import CalendarIcon from "@/components/Icon/icons/CalendarIcon.vue";
import CalendarHistoryIcon from "@/components/Icon/icons/CalendarHistoryIcon.vue";
import CalendarHistoryWarningIcon from "@/components/Icon/icons/CalendarHistoryWarningIcon.vue";
import CalendarNextIcon from "@/components/Icon/icons/CalendarNextIcon.vue";
import CalendarPreviousIcon from "@/components/Icon/icons/CalendarPreviousIcon.vue";
import CalendarRangeArrowIcon from "@/components/Icon/icons/CalendarRangeArrowIcon.vue";
import CalendarRangeClearIcon from "@/components/Icon/icons/CalendarRangeClearIcon.vue";
import CameraIcon from "@/components/Icon/icons/CameraIcon.vue";
import CargoIcon from "@/components/Icon/icons/CargoIcon.vue";
import CheckIcon from "@/components/Icon/icons/CheckIcon.vue";
import CircleIcon from "@/components/Icon/icons/CircleIcon.vue";
import CircleCheckIcon from "@/components/Icon/icons/CircleCheckIcon.vue";
import ChevronDownIcon from "@/components/Icon/icons/ChevronDownIcon.vue";
import ChevronLeftIcon from "@/components/Icon/icons/ChevronLeftIcon.vue";
import ChevronRightIcon from "@/components/Icon/icons/ChevronRightIcon.vue";
import ChevronUpIcon from "@/components/Icon/icons/ChevronUpIcon.vue";
import ClipboardCheckIcon from "@/components/Icon/icons/ClipboardCheckIcon.vue";
import CloseIcon from "@/components/Icon/icons/CloseIcon.vue";
import CommentIcon from "@/components/Icon/icons/CommentIcon.vue";
import ContactIcon from "@/components/Icon/icons/ContactIcon.vue";
import CopyIcon from "@/components/Icon/icons/CopyIcon.vue";
import DataSourceIcon from "@/components/Icon/icons/DataSourceIcon.vue";
import DownloadIcon from "@/components/Icon/icons/DownloadIcon.vue";
import DriverIcon from "@/components/Icon/icons/DriverIcon.vue";
import EditIcon from "@/components/Icon/icons/EditIcon.vue";
import EmailIcon from "@/components/Icon/icons/EmailIcon.vue";
import EyeIcon from "@/components/Icon/icons/EyeIcon.vue";
import EyeOffIcon from "@/components/Icon/icons/EyeOffIcon.vue";
import ExternalLinkIcon from "@/components/Icon/icons/ExternalLinkIcon.vue";
import FleetIcon from "@/components/Icon/icons/FleetIcon.vue";
import GripIcon from "@/components/Icon/icons/GripIcon.vue";
import HelpCenterIcon from "@/components/Icon/icons/HelpCenterIcon.vue";
import HomeAnalyticsIcon from "@/components/Icon/icons/HomeAnalyticsIcon.vue";
import HomeCalculatorIcon from "@/components/Icon/icons/HomeCalculatorIcon.vue";
import HomeIntegrationsIcon from "@/components/Icon/icons/HomeIntegrationsIcon.vue";
import HomeOrdersIcon from "@/components/Icon/icons/HomeOrdersIcon.vue";
import HomeProfileIcon from "@/components/Icon/icons/HomeProfileIcon.vue";
import HomeSettingsIcon from "@/components/Icon/icons/HomeSettingsIcon.vue";
import HomeTelemetryIcon from "@/components/Icon/icons/HomeTelemetryIcon.vue";
import HomeUsersIcon from "@/components/Icon/icons/HomeUsersIcon.vue";
import ImageIcon from "@/components/Icon/icons/ImageIcon.vue";
import InfoIcon from "@/components/Icon/icons/InfoIcon.vue";
import InfoCircleIcon from "@/components/Icon/icons/InfoCircleIcon.vue";
import KeyIcon from "@/components/Icon/icons/KeyIcon.vue";
import LayersIcon from "@/components/Icon/icons/LayersIcon.vue";
import LicenseIcon from "@/components/Icon/icons/LicenseIcon.vue";
import LinkIcon from "@/components/Icon/icons/LinkIcon.vue";
import LockIcon from "@/components/Icon/icons/LockIcon.vue";
import MaxIcon from "@/components/Icon/icons/MaxIcon.vue";
import MapFullscreenIcon from "@/components/Icon/icons/MapFullscreenIcon.vue";
import MegaphoneIcon from "@/components/Icon/icons/MegaphoneIcon.vue";
import MenuIcon from "@/components/Icon/icons/MenuIcon.vue";
import PassportIcon from "@/components/Icon/icons/PassportIcon.vue";
import PauseIcon from "@/components/Icon/icons/PauseIcon.vue";
import PaperclipIcon from "@/components/Icon/icons/PaperclipIcon.vue";
import ParticipantsIcon from "@/components/Icon/icons/ParticipantsIcon.vue";
import PaymentIcon from "@/components/Icon/icons/PaymentIcon.vue";
import PhoneIcon from "@/components/Icon/icons/PhoneIcon.vue";
import PlayIcon from "@/components/Icon/icons/PlayIcon.vue";
import PinIcon from "@/components/Icon/icons/PinIcon.vue";
import PlanNavIcon from "@/components/Icon/icons/PlanNavIcon.vue";
import PulseIcon from "@/components/Icon/icons/PulseIcon.vue";
import RestoreIcon from "@/components/Icon/icons/RestoreIcon.vue";
import RouteIcon from "@/components/Icon/icons/RouteIcon.vue";
import SendIcon from "@/components/Icon/icons/SendIcon.vue";
import SensorIcon from "@/components/Icon/icons/SensorIcon.vue";
import SettingsIcon from "@/components/Icon/icons/SettingsIcon.vue";
import SearchIcon from "@/components/Icon/icons/SearchIcon.vue";
import ShareIcon from "@/components/Icon/icons/ShareIcon.vue";
import SabyIcon from "@/components/Icon/icons/SabyIcon.vue";
import StarIcon from "@/components/Icon/icons/StarIcon.vue";
import StatusMovingIcon from "@/components/Icon/icons/StatusMovingIcon.vue";
import StatusOfflineIcon from "@/components/Icon/icons/StatusOfflineIcon.vue";
import StatusStoppedIcon from "@/components/Icon/icons/StatusStoppedIcon.vue";
import SummaryIcon from "@/components/Icon/icons/SummaryIcon.vue";
import SyncIcon from "@/components/Icon/icons/SyncIcon.vue";
import TemperatureIcon from "@/components/Icon/icons/TemperatureIcon.vue";
import TimeIcon from "@/components/Icon/icons/TimeIcon.vue";
import TrailerIcon from "@/components/Icon/icons/TrailerIcon.vue";
import TruckIcon from "@/components/Icon/icons/TruckIcon.vue";
import TruckoIcon from "@/components/Icon/icons/TruckoIcon.vue";
import TrashIcon from "@/components/Icon/icons/TrashIcon.vue";
import UploadIcon from "@/components/Icon/icons/UploadIcon.vue";
import VolumeIcon from "@/components/Icon/icons/VolumeIcon.vue";
import SpeakerIcon from "@/components/Icon/icons/SpeakerIcon.vue";
import WeightIcon from "@/components/Icon/icons/WeightIcon.vue";
import WrenchIcon from "@/components/Icon/icons/WrenchIcon.vue";
import TransferIcon from "@/components/Icon/icons/TransferIcon.vue";
import StockWriteoffIcon from "@/components/Icon/icons/StockWriteoffIcon.vue";
import StockReceiptIcon from "@/components/Icon/icons/StockReceiptIcon.vue";

import PersonOutlineIcon from "@/components/Icon/icons/PersonOutlineIcon.vue";

import DocumentOutlineIcon from "@/components/Icon/icons/DocumentOutlineIcon.vue";

import InfoFilledIcon from "@/components/Icon/icons/InfoFilledIcon.vue";

import RunningIcon from "@/components/Icon/icons/RunningIcon.vue";

const ICONS = {
  running: RunningIcon,
  infoFilled: InfoFilledIcon,
  documentOutline: DocumentOutlineIcon,
  personOutline: PersonOutlineIcon,
  stockReceipt: StockReceiptIcon,
  transfer: TransferIcon,
  stockWriteoff: StockWriteoffIcon,
  addSquare: AddSquareIcon,
  bell: BellIcon,
  calibration: CalibrationIcon,
  calendar: CalendarIcon,
  calendarHistory: CalendarHistoryIcon,
  calendarHistoryWarning: CalendarHistoryWarningIcon,
  calendarNext: CalendarNextIcon,
  calendarPrevious: CalendarPreviousIcon,
  calendarRangeArrow: CalendarRangeArrowIcon,
  calendarRangeClear: CalendarRangeClearIcon,
  camera: CameraIcon,
  cargo: CargoIcon,
  check: CheckIcon,
  circle: CircleIcon,
  circleCheck: CircleCheckIcon,
  chevronDown: ChevronDownIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  chevronUp: ChevronUpIcon,
  clipboardCheck: ClipboardCheckIcon,
  close: CloseIcon,
  comment: CommentIcon,
  contact: ContactIcon,
  copy: CopyIcon,
  dataSource: DataSourceIcon,
  download: DownloadIcon,
  driver: DriverIcon,
  edit: EditIcon,
  email: EmailIcon,
  externalLink: ExternalLinkIcon,
  eye: EyeIcon,
  eyeOff: EyeOffIcon,
  fleet: FleetIcon,
  grip: GripIcon,
  helpCenter: HelpCenterIcon,
  homeAnalytics: HomeAnalyticsIcon,
  homeCalculator: HomeCalculatorIcon,
  homeIntegrations: HomeIntegrationsIcon,
  homeOrders: HomeOrdersIcon,
  homeProfile: HomeProfileIcon,
  homeSettings: HomeSettingsIcon,
  homeTelemetry: HomeTelemetryIcon,
  homeUsers: HomeUsersIcon,
  image: ImageIcon,
  info: InfoIcon,
  infoCircle: InfoCircleIcon,
  key: KeyIcon,
  layers: LayersIcon,
  license: LicenseIcon,
  link: LinkIcon,
  lock: LockIcon,
  max: MaxIcon,
  mapFullscreen: MapFullscreenIcon,
  megaphone: MegaphoneIcon,
  menu: MenuIcon,
  passport: PassportIcon,
  pause: PauseIcon,
  paperclip: PaperclipIcon,
  participants: ParticipantsIcon,
  payment: PaymentIcon,
  phone: PhoneIcon,
  play: PlayIcon,
  pin: PinIcon,
  planNav: PlanNavIcon,
  pulse: PulseIcon,
  restore: RestoreIcon,
  route: RouteIcon,
  send: SendIcon,
  sensor: SensorIcon,
  settings: SettingsIcon,
  search: SearchIcon,
  share: ShareIcon,
  saby: SabyIcon,
  star: StarIcon,
  statusMoving: StatusMovingIcon,
  statusOffline: StatusOfflineIcon,
  statusStopped: StatusStoppedIcon,
  summary: SummaryIcon,
  sync: SyncIcon,
  temperature: TemperatureIcon,
  time: TimeIcon,
  trailer: TrailerIcon,
  truck: TruckIcon,
  trucko: TruckoIcon,
  trash: TrashIcon,
  upload: UploadIcon,
  volume: VolumeIcon,
  speaker: SpeakerIcon,
  weight: WeightIcon,
  wrench: WrenchIcon,
};

export default {
  name: "AppIcon",

  iconNames: Object.freeze(Object.keys(ICONS)),

  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
    color: {
      type: String,
      default: undefined,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    iconComponent() {
      return ICONS[this.name] || null;
    },

    iconProps() {
      const props = {
        size: this.size,
        stroke: this.stroke,
      };

      if (this.color) props.color = this.color;
      if (this.name === "star") props.filled = this.filled;
      if (this.variant) props.variant = this.variant;

      return props;
    },
  },
};
</script>
